module.exports = __webpack_public_path__ + "img/logo.7a7355a1.png";